import React, { useEffect } from 'react';
import { Modal, Typography, Descriptions } from 'antd';
import { useQuery } from 'react-query';
import { getUserByID } from 'services/parametersService';

export type CorrespondantsUserModalProps = {
  record?: any;
  onClose?: any;
  visible: boolean;
  refresh: boolean;
  id: number;
};

const CorrespondantsUserModal = ({
  onClose,
  visible = false,
  id,
  refresh,
  ...otherProps
}: CorrespondantsUserModalProps) => {
  const { data: user, refetch, isLoading } = useQuery(
    ['getUserByID', { userid: id }],
    () => getUserByID({ userid: id }).then((res) => res.data),
    {
      enabled: !!id,
    }
  );

  useEffect(() => {
    if (refresh) refetch();
  }, [refresh]);

  return (
    <Modal
      visible={visible}
      width="400px"
      style={{ top: 100 }}
      footer={null}
      destroyOnClose
      onCancel={onClose}
    >
      
          <>
            <Typography.Title level={5}>Correspondant Details</Typography.Title>
            <Descriptions column={1} size="middle">
              <Descriptions.Item label="Name">
                {user?.name }
              </Descriptions.Item>
              <Descriptions.Item label="Phone">
                {user?.phone }
              </Descriptions.Item>
              <Descriptions.Item label="Mobile">
                {user?.mobile }
              </Descriptions.Item>
              <Descriptions.Item label="Email">
                {user?.email}
              </Descriptions.Item>
            </Descriptions>
          </>
      
    </Modal>
  );
};

export default CorrespondantsUserModal;
